'use client'; // Error boundaries must be Client Components

import { useEffect } from 'react';
import styled from 'styled-components';
import * as Sentry from '@sentry/nextjs';
import { Header } from '@components/elements/shared/Header/Header';
import { Button } from '@components/elements/shared/Button/Button';
import { PassedLink } from '@components/elements/shared/ALink/ALink';
import Image from 'next/image';
import Link from 'next/link';

const ImgContainer = styled.div`
    padding-top: 0.5rem;
`;

const P = styled.div`
    padding-top: 1rem;
`;

export default function Error({
    error,
}: {
    error: Error & { digest?: string };
}) {
    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    return (
        <div className='container'>
            <div className='row d-flex justify-content-center'>
                <div className='col-md-12 col-sm-12 d-flex justify-content-center align-items-center flex-column'>
                    <ImgContainer>
                        <Image
                            src='/static/images/box-error.svg'
                            alt='Något gick fel'
                            width={200}
                            height={200}
                        />
                    </ImgContainer>
                    <Header>Oops, något gick fel!</Header>
                    <P>
                        <PassedLink>
                            Om du vill försöka igen kan du gå tillbaka till{' '}
                            <Link href='/login' passHref>
                                startsidan
                            </Link>{' '}
                            och börja om.
                        </PassedLink>
                    </P>
                </div>
                <div className='col-xl-6 col-md-7 col-sm-10'>
                    <Button
                        text='Ge oss feedback'
                        onClick={() =>
                            Sentry.showReportDialog({
                                title: 'Något gick fel',
                                subtitle: 'Teamet har blivit notifierade!',
                                subtitle2:
                                    'Om du vill hjälpa till så kan du fylla i vad som hände här nedan.',
                                labelName: 'Namn',
                                labelEmail: 'Email',
                                labelComments: 'Vad hände?',
                                labelClose: 'Stäng',
                                labelSubmit: 'Skicka felrapport',
                                errorGeneric:
                                    'Din felrapport gick inte att skicka, kan det bli värre? 😭',
                                errorFormEntry:
                                    'En eller flera fält är ogiltiga, korrigera och försök igen.',
                                successMessage:
                                    'Vi har tagit emot din feedback, tack!',
                            })
                        }
                        disabled={undefined}
                        loading={undefined}
                        buttonType={undefined}
                        size={undefined}
                        icon={undefined}
                        loader={undefined}
                    />
                </div>
            </div>
        </div>
    );
}
